/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './SettingSensorView.scss'
import React from 'react'
import { NavigationTabs, TextInput } from '../../atoms'
import SettingTab from '../../organisms/room/SettingTab'
import RoomAction from '../../../action/room'
import { NavigationDrawer, OutlinedButton } from 'ui-library/dist/external/components'

function SettingSensorView(props) {
  const room = props.room
  const tabs = SettingTab.getTabMenus(room.id)
  const toolbar = { label: `宿の設定 [${room.name}]`, items: props.accountMenu }

  return (
    <div id="SettingSensor">
      <NavigationDrawer toolbar={toolbar} navigations={props.navigations} />
      <div className="SettingSensor__NavigationTabs">
        <NavigationTabs className="SettingSensor__NavigationTabs" tabs={tabs}>
          <div className="row">
            <div className="col-sm-8 col-lg-6 col-xl-5">
              <h3 className="title">騒音アラート</h3>
              <p>センサーによる騒音アラートを受け取りたい場合は入力してください</p>
              <div className="alertMail">
                <TextInput value={room.alert_email} type="text" name="alert_email" label={'騒音アラート送信先メールアドレス'} onChange={e => RoomAction.onEdit(room, e)} />
                <OutlinedButton disabled={!props.settingSensor.alertEmailChanged} onClick={e => RoomAction.onRequestUpdate(room)}>
                  保存
                </OutlinedButton>
              </div>
            </div>
          </div>
        </NavigationTabs>
      </div>
    </div>
  )
}

export default SettingSensorView
